import { hasValue } from '../../../../general/js/general-helpers';
import * as types from '../actions/action-types';
import initialState from './initial-state';

export default function itemListFormReducer(state = initialState.itemListForm, action) {
    switch (action.type) {
        case types.LOAD_ITEM_LIST_FORM_DATA_SUCCESS:
            return {
                ...state,
                isFormLoadSuccessful: true,
                itemListFormData: hasValue(action.itemListFormData) ? action.itemListFormData : {},
                itemListErrorMessages: []
            };
        case types.LOAD_ITEM_LIST_FORM_DATA_ERROR:
            return {
                ...state,
                isFormLoadSuccessful: false,
                itemListFormData: {},
                itemListErrorMessages: action.errorMessage
            };
        default:
            return state;
    }
}
